class Header {
	constructor() {
		this.navigationWrapper = document.querySelector('header');
		this.toggle = document.querySelector('.toggle');
		// this.fixedNavElement();
	}

	fixedNavElement() {
		// const navigationWrapper = document.querySelector('header');
		// const toggle = document.querySelector('.toggle');
		window.addEventListener("scroll", () => {
			if (window.scrollY > 200) {
				this.navigationWrapper.classList.add('navigation-fixed');
				this.toggle.classList.add('navigation-fixed');
			} else {
				this.navigationWrapper.classList.remove('navigation-fixed');
				this.toggle.classList.remove('navigation-fixed');
			}
		});
	}
}

new Header();
